module.exports = __webpack_public_path__ + "static/5i-72c01f753c3940c0b9cb6bf2389caddf.woff";